import { I18n } from '@features/internationalisation/i18n';
import {
  ExternalUserRegistrationApprovalDecision as Decision,
  ExternalUserRegistrationApprovalDto,
  ExternalUserRegistrationStatus,
} from '@imcc/transport';
import { DateBuilder } from '@imcc/utilities';
import { Exclude, Type } from 'class-transformer';

export class ExternalUserRegistration {
  static readonly expirationPeriodLength = 30;

  constructor(initialValues: Partial<ExternalUserRegistration> = {}) {
    Object.assign(this, initialValues);
  }

  givenName = '';

  lastName = '';

  city = '';

  country = '';

  company = '';

  email = '';

  approverEmail = '';

  requesterEmail = '';

  approvals: ExternalUserRegistrationApprovalDto[] = [];

  requesterFullName = '';

  createdAt: Date;

  updatedAt: Date;

  id = '';

  userId = '';

  status: ExternalUserRegistrationStatus =
  ExternalUserRegistrationStatus.pending;

  @Exclude({ toClassOnly: true })
  get fullName(): string {
    return `${this.givenName} ${this.lastName}`;
  }

  @Type(() => Date)
  expirationDate?: Date;

  @Exclude({ toClassOnly: true })
  get validFor(): number | undefined {
    // eslint-disable-next-line max-len
    const approvals = this.approvals.filter(({ decision }) => [Decision.approved, Decision.extended, Decision.requested].includes(decision));
    const approval = approvals[approvals.length - 1];

    if (!approval) {
      return undefined;
    }

    return approval.validFor;
  }

  @Exclude({ toClassOnly: true })
  get isExpiring(): boolean {
    if (!this.expirationDate) {
      return false;
    }

    const dateBuilder = new DateBuilder(this.expirationDate);
    const { expirationPeriodLength } = ExternalUserRegistration;
    const oneMonthFromExpiration = dateBuilder.addDays(-expirationPeriodLength)
      .date;

    return new Date() > oneMonthFromExpiration;
  }

  @Exclude({ toClassOnly: true })
  get isExpired(): boolean {
    if (!this.expirationDate) {
      return false;
    }

    return new Date() > this.expirationDate;
  }

  @Exclude({ toClassOnly: true })
  get humanReadableStatus(): string {
    const { status } = this;

    return I18n.translate(`externalUserRegistration.statuses.${status}`);
  }
}
